import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const MarkersCaps = ({ className }) => (
    <svg
        className={className}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1081.76 685.72"
        enableBackground="new 0 0 1081.76 685.72"
        xmlSpace="preserve"
    >
        <g>
            <path
                fill="#E7C787"
                d="M638.26,235.44h10.76l-6.4-10.06h-4.37V235.44z M638.26,166.07v58.6h4.21v-61.44h-5.94
	C637.56,163.76,638.26,164.83,638.26,166.07z M649.66,236.14h-31.51h-18.77l-0.01,8.96h50.29V236.14z M605.9,163.23h-3.64
	c-1.57,0-2.83,1.27-2.83,2.83l-0.04,69.16l6.52-10.3V163.23z M610.82,166.07c0-1.23,0.7-2.3,1.73-2.83h-5.94v61.44h4.21V166.07z
	 M610.82,235.44v-10.06h-4.37l-6.37,10.06H610.82z M611.53,166.07v69.37h1.29v-69.37c0-1,0.47-1.9,1.19-2.48
	C612.64,163.59,611.53,164.7,611.53,166.07z M599.37,263.47h50.34c0.78,0,1.42-0.63,1.42-1.42V247.1c0-0.57-0.33-1.06-0.84-1.28
	h-51.52c-0.48,0.23-0.82,0.72-0.82,1.28v14.95C597.95,262.83,598.59,263.47,599.37,263.47z M636.26,235.44h1.29v-69.37
	c0-1.37-1.11-2.48-2.48-2.48c0.72,0.58,1.19,1.48,1.19,2.48V235.44z M649.66,166.07c0-1.57-1.27-2.83-2.83-2.83h-3.64v61.69
	l6.48,10.19V166.07z M613.53,234.32l4.77-9.31v-61.42h-2.29c-1.37,0-2.48,1.11-2.48,2.48V234.32z M635.56,166.07
	c0-1.37-1.11-2.48-2.48-2.48h-2.29v61.26l4.77,9.46V166.07z M618.15,235.44h17.18l-5.07-10.06H618.9l-5.15,10.06H618.15z
	 M630.08,163.59h-2.01H619v61.08h11.08V163.59z"
            />
        </g>
        <g>
            <path
                fill="#E7C787"
                d="M706.37,260.37c0-1.57-1.27-2.83-2.83-2.83h-1.37v47.5l4.2,5.97V260.37z M706.37,311.97h-38.28l-0.01,15.63
	h38.29V311.97z M707.84,334.33v-4.95c0-0.42-0.19-0.8-0.49-1.06h-40.21c-0.29,0.26-0.48,0.64-0.48,1.06v4.95
	c0,0.78,0.63,1.42,1.42,1.42h38.34C707.2,335.74,707.84,335.11,707.84,334.33z M672.31,257.53h-1.34c-1.57,0-2.84,1.27-2.84,2.83
	l-0.04,50.69l4.22-6.02V257.53z M677.48,260.37c0-1.23,0.7-2.3,1.73-2.83h-6.19v47.26h4.46V260.37z M697,260.37v44.43h4.46v-47.26
	h-6.19C696.3,258.06,697,259.13,697,260.37z M695,311.27h1.29v-50.9c0-1.37-1.11-2.48-2.48-2.48c0.72,0.58,1.19,1.48,1.19,2.48
	V311.27z M694.29,260.37c0-1.12-0.74-2.07-1.76-2.37v46.98l1.76,4.72V260.37z M691.82,304.79l-0.01-46.91h-4.23h-3h-1.92v46.91h6.28
	H691.82z M677.48,311.27v-5.76h-4.63l-4.04,5.76H677.48z M678.19,260.37v50.9h1.29v-50.9c0-1,0.47-1.9,1.19-2.48
	C679.3,257.89,678.19,259,678.19,260.37z M694.12,311.27l-2.15-5.76h-3.99h-5.46l-2.17,5.76H694.12z M697,311.27h8.69l-4.06-5.76
	H697V311.27z M680.19,309.7l1.76-4.68v-47.03c-1.02,0.31-1.76,1.25-1.76,2.38V309.7z"
            />
        </g>
        <g>
            <path
                fill="#E7C787"
                d="M517.19,218.34h-13.85l8.76-10.57h5.1V218.34z M517.19,169.88v37.18h-4.91v-40.99h7.39
	C518.21,166.71,517.19,168.17,517.19,169.88z M517.9,169.88c0-1.91,1.55-3.46,3.46-3.46l0.5,0c-1.11,0.75-1.84,2.02-1.84,3.46
	l0,92.35h-2.12V169.88z M520.73,169.88c0-1.6,1.09-2.95,2.57-3.34v40.83l-2.57,8.87V169.88z M511.57,166.06v41.22l-9.03,10.9v-48.85
	c0-1.81,1.71-3.27,3.83-3.27L511.57,166.06z M520.73,262.23v-43.18h14.08v43.18H520.73z M517.19,219.04v43.18h-14.65v-43.18H517.19z
	 M570.4,285.27h-67.73c-1.05,0-1.91-0.81-1.91-1.81V264.4c0-0.6,0.31-1.13,0.79-1.46h69.96c0.49,0.33,0.8,0.86,0.8,1.46v19.06
	C572.3,284.46,571.45,285.27,570.4,285.27z M555.68,169.88c0-1.7-1.02-3.17-2.48-3.81h7.39v40.99h-4.91V169.88z M552.85,169.88
	c0-1.44-0.73-2.71-1.84-3.46h0.5c1.91,0,3.46,1.55,3.46,3.46v92.35h-2.12V169.88z M555.68,262.23v-43.18h14.65v43.18H555.68z
	 M570.33,169.33v48.85l-9.03-10.9v-41.22l5.21,0C568.62,166.06,570.33,167.53,570.33,169.33z M534.8,218.34h-13.95l3.06-10.57h10.89
	V218.34z M555.68,218.34v-10.57h5.1l8.76,10.57H555.68z M537.49,166.42v95.81h-2.12v-95.81h0.91h0.3H537.49z M534.8,166.42v40.64
	h-10.8v-40.64l0.18,0H534.8z M548.96,207.77l3.06,10.57h-13.97v-10.57H548.96z M552.14,169.88v46.29l-2.55-8.81v-40.82
	C551.05,166.94,552.14,168.28,552.14,169.88z M548.87,166.42v40.63h-10.81v-40.64h10.62L548.87,166.42z M552.14,219.04v43.18h-14.08
	v-43.18H552.14z M557.45,216.7c1.56,0,2.83,1.27,2.83,2.83l0.01,18.57h-48.2v-18.57c0-1.57,1.27-2.83,2.83-2.83H557.45z
	 M509.26,241.3c0-1.08,0.6-2.01,1.48-2.49h50.9c0.88,0.48,1.48,1.42,1.48,2.49v19.45h-53.87V241.3z M506.72,264.78l2.31-3.3h54.32
	l2.31,3.3H506.72z M503.81,275.9l2.44-4.7h59.87l2.44,4.7H503.81z M506.43,270.49v-5h59.53v5H506.43z M503.59,287.23v-10.62h65.2
	v10.62H503.59z"
            />
        </g>
        <g>
            <path
                fill="#E7C787"
                d="M893.28,145.17c0-1.57-1.27-2.83-2.83-2.83h-1.37v47.5l4.2,5.97V145.17z M893.28,196.78H855l-0.01,15.63
	h38.29V196.78z M854.99,220.55h38.34c0.78,0,1.42-0.63,1.42-1.42v-4.95c0-0.42-0.19-0.8-0.49-1.06h-40.21
	c-0.29,0.26-0.48,0.64-0.48,1.06v4.95C853.57,219.91,854.21,220.55,854.99,220.55z M859.22,142.34h-1.34
	c-1.57,0-2.83,1.27-2.83,2.83L855,195.86l4.22-6.02V142.34z M863.39,145.17c0-1.23,0.7-2.3,1.73-2.83h-5.19v47.26h3.46V145.17z
	 M884.91,145.17v44.43h3.46v-47.26h-5.19C884.21,142.87,884.91,143.94,884.91,145.17z M882.91,196.07h1.29v-50.9
	c0-1.37-1.11-2.48-2.48-2.48c0.72,0.58,1.19,1.48,1.19,2.48V196.07z M882.2,145.17c0-1.12-0.74-2.07-1.76-2.37v46.98l1.76,4.72
	V145.17z M879.73,189.6l-0.01-46.91h-5.23h-4h-1.92v46.91h7.28H879.73z M863.39,196.07v-5.76h-3.63l-4.04,5.76H863.39z
	 M864.1,145.17v50.9h1.29v-50.9c0-1,0.47-1.9,1.19-2.48C865.21,142.69,864.1,143.8,864.1,145.17z M882.03,196.07l-2.15-5.76h-4.99
	l-6.46,0l-2.17,5.76H882.03z M884.91,196.07h7.69l-4.06-5.76h-3.63V196.07z M866.1,194.51l1.76-4.68v-47.03
	c-1.02,0.31-1.76,1.25-1.76,2.38V194.51z"
            />
        </g>
    </svg>
);

MarkersCaps.propTypes = propTypes;
MarkersCaps.defaultProps = defaultProps;

export default MarkersCaps;
